const stateEnum = {
  JOIN_DISCUSS: 0, //我要洽谈
  SEE_CONTACT: 1,  //查看联系方式
  SUBSCRIBE: 2, //预约
  CANCELSUB: 3, //取消预约
}
export {
  stateEnum
}
